"use strict";

class AuthInviteCtrl {

	/**
	 * [constructor description]
	 * @param  {[type]} $http [description]
	 * @return {[type]}       [description]
	 */
	constructor ( $http ) {

		let csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

		this.$http = $http;

		// Defaults
		this.formdata = {
			_token: csrftoken
		};

		this.status = {
			error: false,
			errorMessages: [],
			sending: false
		};
	}

	/**
	 * [submit description]
	 * @param  {Boolean} isValid [description]
	 * @return {[type]}          [description]
	 */
	submit ( isValid ) {

		if (!isValid) {

			return;
		}

		this.status.sending = true;
		this.status.error = false;
		this.status.errorMessages.length = 0;

		this.$http.post('/auth/linknewuser', this.formdata)
			.then(( data, status ) => {

				// Login successfull!
				this.status.sending = false;
				window.location.replace('/');
			}, ( errors ) => {

				// Extract Laravel errors
				Object.getOwnPropertyNames(errors).forEach(( fieldName ) => {

					errors[fieldName].forEach(( message ) => {

						this.status.errorMessages.push(message);
					});
				});

				this.status.error = true;
				this.status.sending = false;
			});
	}
}

AuthInviteCtrl.$inject = ['$http'];

module.exports = AuthInviteCtrl;

